export const PATHS = {
  PLANTS_HELP_DOC: "/DocumentLibrary/Docx/PLANTS_Help_Document.docx",
  PLANTS_HELP_PDF_2022: "/DocumentLibrary/Pdf/PLANTS_Help_Document_2022.pdf",
  PLANTS_HELP_PDF: "/DocumentLibrary/Pdf/PLANTS_Help_Document.pdf",
  NRCS_POLLINATOR: "/DocumentLibrary/Pdf/NRCS_Pollinator_PLANTS_Nov2021.pdf",
  PLANTS_LIST_URL: "/DocumentLibrary/Txt/plantlst.txt",
  NON_LICHEN_FUNGI_LIST_URL: "/DocumentLibrary/Txt/Non_LichenFungi.txt",
  STATE_PLANT_COORDINATOR: "/DocumentLibrary/Pdf/StatePlantsCoordinators.pdf",
  PLANTS_HELP_DOC_WETLAND_STATS_INDICATOR:
    "/DocumentLibrary/Docx/PLANTS_Help_Document.docx#Wetland_Indicator_Status"
};
